import * as React from 'react'

type LogoSebraeProps = {
  width?: number | string
  showText?: boolean
  pinColor?: string
  checkColor?: string
  primaryTextColor?: string
  secondaryTextColor?: string
  title?: string
  className?: string
  style?: React.CSSProperties
}

export default function LogoSebrae({
  width = 420,
  showText = true,
  pinColor,
  checkColor,
  primaryTextColor,
  secondaryTextColor,
  title = 'SEBRAE na sua empresa',
  className,
  style,
}: LogoSebraeProps) {
  const darkBlue = '#0160AD'
  const lightBlue = '#83CFF3'

  const pin = pinColor ?? lightBlue
  const check = checkColor ?? darkBlue
  const primaryText = primaryTextColor ?? darkBlue
  const secondaryText = secondaryTextColor ?? lightBlue

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 330 82'
      width={width}
      role='img'
      aria-label={title}
      className={className}
      style={style}
    >
      <title>{title}</title>

      <g transform='translate(8,14) scale(1.55)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.3738 0.796875C19.0101 0.796875 22.3505 2.09179 24.9774 4.2535L21.2511 7.97969C19.5651 6.48393 17.3558 5.57485 14.9351 5.57485C9.63909 5.57485 5.34734 9.9247 5.34734 15.2893C5.34734 20.654 9.63909 25.0039 14.9351 25.0039C19.581 25.0039 23.4604 21.6529 24.3378 17.2079L30.0408 11.9384C30.4583 13.3602 30.6856 14.8665 30.6856 16.431C30.6856 24.544 20.6486 36.5154 15.3685 42.2077C10.4478 36.3515 0.0566406 24.9774 0.0566406 16.431C0.0566406 7.79998 6.91182 0.80216 15.3738 0.80216V0.796875Z'
          fill={pin}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.1753 9.65518L16.1743 15.1784L27.9872 3.89941L31.7081 7.43004L15.9893 23.2703L6.83496 13.4924L10.1753 9.65518Z'
          fill={check}
        />
      </g>

      {showText && (
        <g transform='translate(0,4)'>
          <text
            x='70'
            y='42'
            fontFamily='Inter, Arial, Helvetica, sans-serif'
            fontWeight={1000}
            fontSize='42'
            fontStyle='italic'
            fill={primaryText}
            letterSpacing='0.5'
          >
            SEBRAE
          </text>

          <text
            x='70'
            y='72'
            fontFamily='Inter, Arial, Helvetica, sans-serif'
            fontWeight={950}
            fontSize='28'
            fontStyle='italic'
            fill={secondaryText}
            letterSpacing='0.2'
          >
            na sua empresa
          </text>
        </g>
      )}
    </svg>
  )
}
